import type { DataImportByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDataImportByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDataImportByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDataImportByIdArgs = {
  id: string;
};

export const useGetDataImportById = createQueryHook<
  UseGetDataImportByIdArgs,
  DataImportByIdResponseRow[],
  GetDataImportByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.dataImport.dataImportById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ data_import: data || [] }),
  graphqlDocument: GetDataImportByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
  // Mounted by the update page AND the breadcrumb resolver concurrently; keep
  // Apollo dedup working under cache-first (no-cache trips the vitest warn gate).
  graphqlFetchPolicy: 'cache-first',
});
